/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { absDependencies } from './dependenciesAbs.generated.js';
import { addScalarDependencies } from './dependenciesAddScalar.generated.js';
import { deepEqualDependencies } from './dependenciesDeepEqual.generated.js';
import { divideScalarDependencies } from './dependenciesDivideScalar.generated.js';
import { multiplyScalarDependencies } from './dependenciesMultiplyScalar.generated.js';
import { sqrtDependencies } from './dependenciesSqrt.generated.js';
import { subtractScalarDependencies } from './dependenciesSubtractScalar.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createDistance } from '../../factoriesAny.js';
export var distanceDependencies = {
  absDependencies,
  addScalarDependencies,
  deepEqualDependencies,
  divideScalarDependencies,
  multiplyScalarDependencies,
  sqrtDependencies,
  subtractScalarDependencies,
  typedDependencies,
  createDistance
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesDistance.generated.js
// module id = gyT2
// module chunks = 3